import { Directive, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { NzTooltipDirective, NzTooltipTrigger } from "ng-zorro-antd/tooltip";
import { NgStyleInterface, NzTSType } from "ng-zorro-antd/core/types";
import { TooltipPosition } from "@webapp/ui/tooltip/tooltip.models";
import { InputBoolean } from "ng-zorro-antd/core/util";
/**
 * @example <p ui-tooltip tooltipContent="Content" tooltipPosition="right">Hover me</h1>
 * @param tooltipContent string | TemplateRef
 * @param tooltipPosition TooltipPosition (default: top)
 * @param tooltipContainerClass string (default: ui-tooltip)
 * @param tooltipContainer string
 * @param tooltipDisabled boolean (default: 0)
 */
@Directive({
  selector: "[ui-tooltip]",
})
export class UiTooltipDirective extends NzTooltipDirective {
  @Input("tooltipContent") title?: NzTSType | null;
  @Input("tooltipTitleContext") titleContext?: object | null = null;
  @Input("ui-tooltip") directiveTitle?: NzTSType | null;
  @Input("tooltipTrigger") trigger?: NzTooltipTrigger = "hover";
  @Input("tooltipPosition") placement?: TooltipPosition | TooltipPosition[] = "top";
  @Input("tooltipOrigin") origin?: ElementRef<HTMLElement>;
  @Input("tooltipVisible") visible?: boolean;
  @Input("tooltipMouseEnterDelay") mouseEnterDelay?: number;
  @Input("tooltipMouseLeaveDelay") mouseLeaveDelay?: number;
  @Input("tooltipContainerClass") overlayClassName = "ui-tooltip";
  @Input("tooltipOverlayStyle") overlayStyle?: NgStyleInterface;
  @Input("tooltipArrowPointAtCenter") @InputBoolean() arrowPointAtCenter?: boolean;
  @Input() tooltipColor?: string;

  @Output("tooltipVisibleChange") readonly visibleChange = new EventEmitter<boolean>();

  @Input("tooltipContainer")
  tooltipContainer?: string | ElementRef;
  @Input()
  tooltipDisabled?: boolean = false;

  ngOnInit() {
    if (!this.tooltipDisabled) {
      this.setOrigin();
    }
  }

  private setOrigin(): void {
    if (this.tooltipContainer) {
      if (typeof this.tooltipContainer === "string") {
        let element: Element;
        if (this.tooltipContainer.indexOf(".") === 0) {
          const elements = document.getElementsByClassName(this.tooltipContainer);
          if (elements.length) {
            element = elements[0];
          }
        } else if (this.tooltipContainer.indexOf("#") === 0) {
          element = document.getElementById(this.tooltipContainer);
        } else {
          const elements = document.getElementsByTagName(this.tooltipContainer);
          if (elements.length) {
            element = elements[0];
          }
        }
        if (element) {
          this.origin = new ElementRef(element as HTMLElement);
        }
      } else {
        this.origin = this.tooltipContainer;
      }
    }
  }
}
